import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

const countryCodes = [
  { code: '+967', country: 'اليمن' },
  { code: '+249', country: 'السودان' },
  { code: '+20', country: 'مصر' },
  { code: '+966', country: 'السعودية' },
];

function ResetPassword() {
  const [phone, setPhone] = useState('');
  const [countryCode, setCountryCode] = useState('+967');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSuccess(false);
    setLoading(true);

    try {
      const response = await fetch(
        `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/reset-password`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${import.meta.env.VITE_SUPABASE_ANON_KEY}`,
          },
          body: JSON.stringify({
            phone: phone.trim(),
            countryCode,
          }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'حدث خطأ أثناء إرسال رابط إعادة تعيين كلمة المرور');
      }

      setSuccess(true);
    } catch (err) {
      console.error('Reset password error:', err);
      setError(err instanceof Error ? err.message : 'حدث خطأ أثناء إرسال رابط إعادة تعيين كلمة المرور');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100 flex flex-col">
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-sm bg-white rounded-3xl shadow-lg p-8">
          <div className="text-center mb-8">
            <h1 className="text-2xl font-semibold text-gray-800 mb-2">استعادة كلمة المرور</h1>
            <p className="text-gray-600">أدخل رقم هاتفك لاستعادة كلمة المرور</p>
          </div>

          {error && (
            <div className="mb-4 p-3 bg-red-50 text-red-600 rounded-lg text-sm">
              {error}
            </div>
          )}

          {success && (
            <div className="mb-4 p-3 bg-green-50 text-green-600 rounded-lg text-sm">
              تم إرسال رابط إعادة تعيين كلمة المرور إلى بريدك الإلكتروني
            </div>
          )}

          <form className="space-y-4" onSubmit={handleSubmit}>
            <div>
              <select
                value={countryCode}
                onChange={(e) => setCountryCode(e.target.value)}
                className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:outline-none focus:border-blue-500 bg-white"
                required
              >
                {countryCodes.map((country) => (
                  <option key={country.code} value={country.code}>
                    {country.country} ({country.code})
                  </option>
                ))}
              </select>
            </div>

            <div>
              <input
                type="tel"
                placeholder="رقم الهاتف"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:outline-none focus:border-blue-500"
                required
              />
              <p className="mt-1 text-sm text-gray-500">
                أدخل رقم الهاتف كما هو مسجل في حسابك
              </p>
            </div>

            <button
              type="submit"
              disabled={loading || success}
              className="w-full py-3 bg-[#F87171] text-white rounded-xl hover:bg-[#EF4444] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? 'جاري المعالجة...' : 'إرسال رابط إعادة التعيين'}
            </button>
          </form>

          <p className="mt-8 text-center text-sm text-gray-500">
            تذكرت كلمة المرور؟{' '}
            <button 
              onClick={() => navigate('/login')} 
              className="text-blue-500 hover:text-blue-600"
            >
              تسجيل الدخول
            </button>
          </p>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;